module.exports = __webpack_public_path__ + "static/img/装饰4.23de989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰4.svg
// module id = VCHD
// module chunks = 2